import './App.css';
import Home from './Components/Home';
import { Routes, Route, Navigate } from "react-router-dom";
import Blogs from './Components/Blogs';
import About from './Components/About';
import Contact from './Components/Contact';
import Feature from './Components/Feature';
import FAQ from './Components/FAQ';
import Comingsoon from './Components/Comingsoon';

function App() {
  return (
    <Routes>
    <Route path="/" element={<Home />} />
     <Route path="/Blogs" element={<Blogs/>} />
     <Route path="/Aboutus" element={<About/>} />
     <Route path="/Contactus" element={<Contact/>} />
     <Route path="/Feature" element={<Feature/>} />
     <Route path="/FAQ" element={<FAQ/>} />
    <Route path="*" element={<Comingsoon />} /> 
  </Routes>
  );
}

export default App;
